export const baseGoogleFontsUrl = 'https://fonts.googleapis.com/css?family';
export const baseCustomFontsUrl = () => 'https://static.minutemedia.com/static/fonts';
